import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const getProfileApi = createAsyncThunk(
  'user/getProfileApi',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/users/profile');
      return response.data;
    } catch (error) {
      return handleApiError('getProfileApi', error, rejectWithValue);
    }
  },
);

export const updateProfileApi = createAsyncThunk(
  'user/updateProfileApi',
  async ({ userId, profileData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/users/${userId}/profile`, profileData);
      return response.data;
    } catch (error) {
      return handleApiError('updateProfileApi', error, rejectWithValue);
    }
  },
);

export const changePasswordApi = createAsyncThunk(
  'user/changePasswordApi',
  async ({ userId, passwordData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/users/${userId}/change-password`, passwordData);
      return response.data;
    } catch (error) {
      return handleApiError('changePasswordApi', error, rejectWithValue);
    }
  },
);

export const deleteUserApi = createAsyncThunk(
  'user/deleteUserApi',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      return handleApiError('deleteUserApi', error, rejectWithValue);
    }
  },
);
